"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInputSchema = void 0;
exports.default = SelectInput;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("zod");
exports.SelectInputSchema = ((options) => {
    return {
        options,
        create: (fieldName, validation) => {
            return zod_1.z.object({ [fieldName]: validation });
        },
    };
})({
    default: zod_1.z.string().min(1, 'Required'),
    notRequired: zod_1.z.string(),
});
function SelectInput({ label, name, required = true, formHelperText, options, disabled = false, }) {
    const { control } = (0, react_hook_form_1.useFormContext)();
    const labelId = (0, react_1.useId)();
    const { field, formState: { errors }, } = (0, react_hook_form_1.useController)({ name, control });
    const error = errors[name];
    return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, { fullWidth: true, error: !!error, required: required, children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { id: labelId, disabled: disabled, children: label }), (0, jsx_runtime_1.jsx)(material_1.Select, Object.assign({ label: label, labelId: labelId }, field, { disabled: disabled, children: Object.keys(options).length > 0 &&
                    (options === null || options === void 0 ? void 0 : options.map((option) => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: option.value, children: (0, jsx_runtime_1.jsx)(material_1.ListItemText, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "bodyMediumBook", children: option.label }) }) }, option.value)))) })), (0, jsx_runtime_1.jsx)(material_1.FormHelperText, { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (error === null || error === void 0 ? void 0 : error.message) || formHelperText }) })] }));
}
//# sourceMappingURL=SelectInput.js.map